// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class InjectionToken {
    key;
    ___;
    constructor(key) {
        this.key = key;
        if (typeof key !== 'string' || !key.trim()) {
            throw new Error('Invalid InjectionToken name!');
        }
        this.___ = key;
    }
}
//# sourceMappingURL=token.js.map